const INITIAL_STATE = {
  notifications: 0,
  pedidos: 0,
  refounds: 0,
};

export default function setcounters(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.notifications,
      };
    case 'SET_PEDIDOS_COUNTER':
      return {
        ...state,
        pedidos: action.pedidos,
      };
    case 'SET_REFOUNDS_COUNTER':
      return {
        ...state,
        refounds: action.refounds,
      };
    default:
      return state;
  }
}
